"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddingPresetNameSchema = exports.EMBEDDING_PRESETS = exports.EmbeddingDimension = exports.EmbeddingProvider = exports.EmbeddingPresetName = void 0;
exports.isEmbeddingPresetName = isEmbeddingPresetName;
exports.getEmbeddingPreset = getEmbeddingPreset;
const zod_1 = require("zod");
var EmbeddingPresetName;
(function (EmbeddingPresetName) {
    EmbeddingPresetName["Openai3Large1024"] = "openai-3-large-1024";
    EmbeddingPresetName["Openai3Small1536"] = "openai-3-small-1536";
    EmbeddingPresetName["TitanV2_512"] = "titan-v2-512";
    EmbeddingPresetName["TitanV2_1024"] = "titan-v2-1024";
})(EmbeddingPresetName || (exports.EmbeddingPresetName = EmbeddingPresetName = {}));
var EmbeddingProvider;
(function (EmbeddingProvider) {
    EmbeddingProvider["OpenAI"] = "OpenAI";
    EmbeddingProvider["AWSBedrock"] = "AWSBedrock";
})(EmbeddingProvider || (exports.EmbeddingProvider = EmbeddingProvider = {}));
var EmbeddingDimension;
(function (EmbeddingDimension) {
    EmbeddingDimension[EmbeddingDimension["Dim256"] = 256] = "Dim256";
    EmbeddingDimension[EmbeddingDimension["Dim512"] = 512] = "Dim512";
    EmbeddingDimension[EmbeddingDimension["Dim1024"] = 1024] = "Dim1024";
    EmbeddingDimension[EmbeddingDimension["Dim1536"] = 1536] = "Dim1536";
})(EmbeddingDimension || (exports.EmbeddingDimension = EmbeddingDimension = {}));
exports.EMBEDDING_PRESETS = {
    [EmbeddingPresetName.Openai3Large1024]: {
        displayName: 'OpenAI text-embedding-3-large (reduced to 1024)',
        provider: EmbeddingProvider.OpenAI,
        modelId: 'text-embedding-3-large',
        dimensions: EmbeddingDimension.Dim1024,
        providerOptions: {},
    },
    [EmbeddingPresetName.Openai3Small1536]: {
        displayName: 'OpenAI text-embedding-3-small (1536)',
        provider: EmbeddingProvider.OpenAI,
        modelId: 'text-embedding-3-small',
        dimensions: EmbeddingDimension.Dim1536,
        providerOptions: {},
    },
    [EmbeddingPresetName.TitanV2_512]: {
        displayName: 'AWS Titan Text Embeddings V2 (512)',
        provider: EmbeddingProvider.AWSBedrock,
        modelId: 'amazon.titan-embed-text-v2:0',
        dimensions: EmbeddingDimension.Dim512,
        providerOptions: {
            normalize: true,
        },
    },
    [EmbeddingPresetName.TitanV2_1024]: {
        displayName: 'AWS Titan Text Embeddings V2 (1024)',
        provider: EmbeddingProvider.AWSBedrock,
        modelId: 'amazon.titan-embed-text-v2:0',
        dimensions: EmbeddingDimension.Dim1024,
        providerOptions: {
            normalize: true,
        },
    },
};
exports.EmbeddingPresetNameSchema = zod_1.z.nativeEnum(EmbeddingPresetName);
function isEmbeddingPresetName(name) {
    return Object.values(EmbeddingPresetName).includes(name);
}
function getEmbeddingPreset(name) {
    return exports.EMBEDDING_PRESETS[name];
}
//# sourceMappingURL=embedding-presets.js.map